// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DownOutlinedSvg from "@fishx/icons-svg/es/asn/DownOutlined";
import FishxIcon from '../components/FishxIcon';

var DownOutlined = function DownOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DownOutlinedSvg
  }));
};

DownOutlined.displayName = 'DownOutlined';
export default React.forwardRef(DownOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DownOutlined.js
// module id = 2462
// module chunks = 0